import { Badge } from '@/components/ui/badge';

function formatVerifiedDate(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

export function FacilityVerificationBadge({ facility, testId = 'facility-verification-badge' }) {
  const verifiedDate = formatVerifiedDate(facility?.verified_at);
  const verifiedBy = facility?.verified_by_name || 'team';
  if (facility?.is_verified && verifiedDate) {
    return <Badge className="border border-emerald-200 bg-emerald-50 text-emerald-700" data-testid={testId}>Verified {verifiedDate} · {verifiedBy}</Badge>;
  }
  if (facility?.is_verified) {
    return <Badge className="border border-emerald-200 bg-emerald-50 text-emerald-700" data-testid={testId}>Verified · {verifiedBy}</Badge>;
  }
  return <Badge className="border border-amber-200 bg-amber-50 text-amber-800" data-testid={testId}>Needs verification</Badge>;
}